// Vendor imports
const cookie = require('js-cookie')
// Client V2 common imports
const extension = require('client-v2/common/utils/extension')

const UPDATE_EXTENSION_INSTALLED = 'ENVIRONMENT_UPDATE_EXTENSION_INSTALLED'

function checkForExtension() {
  return function (dispatch, getState) {
    const wasInstalled = getState().env.extensionInstalled
    const isInstalled = extension.isInstalled()
    if (isInstalled && !cookie.get('mix-ext')) {
      cookie.set('mix-ext', '1', {
        sameSite: 'strict',
        secure: location.protocol === 'https:'
      })
    } else if (!isInstalled) {
      cookie.remove('mix-ext')
    }
    if (wasInstalled !== isInstalled) {
      dispatch({
        type: UPDATE_EXTENSION_INSTALLED,
        payload: isInstalled
      })
    }
  }
}

module.exports = {
  UPDATE_EXTENSION_INSTALLED,
  checkForExtension
}
